var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._l((_vm.entries),function(entry,idx){return [_c('Address',{key:entry.email,attrs:{"email":entry.email,"label":entry.label}}),(idx + 1 < _vm.entries.length)?_c('span',{key:entry.email},[_vm._v(", ")]):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }